<template>
    <div>
        <b-form-group label="Email Cliente" label-for="client_email_person">
            <b-form-input v-model="clientEmail" placeholder="Email Cliente" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" className="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        clientEmail: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localClientEmail: this.clientEmail,
        }
    },
    watch: {
        clientEmail(newVal) {
            this.localClientEmail = newVal
            this.$emit('update', { client_email: this.localClientEmail })
        },
    },
}
</script>
